module.exports = __webpack_public_path__ + "static/media/gothamknights.be3fac84.png";